const BIRTH_DATE = new Date(1996, 11, 26)

/**
 * @returns the current age of myself
 */
export function getCurrentAge(): number {
  return new Date((+new Date() - +BIRTH_DATE)).getFullYear() - 1970;
}